import React, { useState } from 'react';

import { AddName } from './TextField';
import { ConfirmBtn } from './Button';

import { Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        marginTop: '2vh',
    },
    Content : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    label : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1rem !important',
    },
    dialog : {
        backgroundColor : 'black',
        color : 'white',
        boxShadow: '-1px -1px 10px 0px #1c1c1c',
    },
}));

const CreateRoomDialog =  function CreateRoomDialog({ show, updatedNameCallBack }){

    const classes = useStyles();
    const [ name, setName ] = useState('');

    var handleDialogClose = () => {

        if(name !== '') {
            localStorage.setItem('UserName', name);
            updatedNameCallBack(true);
        } else {
            updatedNameCallBack(false);
        }

    }

    var handleUserNameChange = (name) => {

        setName(name);

    }

    return(
        <Dialog classes={{ paper : classes.dialog }} open={show || false} >
            <DialogTitle  disableTypography={true} classes={{ root : classes.Title }} >
                Display Name
            </DialogTitle>
            <DialogContent classes={{ root : classes.Content }} >
                <List>
                    <ListItem>
                        <AddName getName={handleUserNameChange} />
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <ConfirmBtn handleClick={handleDialogClose}  />
            </DialogActions>
        </Dialog>
    )

}

export default CreateRoomDialog;